import type { VoidFunctionComponent } from 'react';

import FallbackImage from '../../../generic/FallbackImage';

import styles from './emptyStates.module.less';

/**
 * Empty state shown when the project has not yet been analyzed for snippets.
 */
const MissingSnippetAnalysis: VoidFunctionComponent = () => {
  return (
    <div className={`panel ${styles.emptyState}`}>
      <FallbackImage
        src="no-data"
        alt="Snippet analysis has not been run on this revision"
        hasPadding
      >
        <header className={styles.emptyStateHeader}>Snippet analysis has not been run on this revision</header>
        <p className={styles.emptyStateMessage}>
          Run <code>fossa analyze --snippet-scan</code> from your project to see results.
        </p>
      </FallbackImage>
    </div>
  );
};

export default MissingSnippetAnalysis;
